import { cx } from 'class-variance-authority';
import { Fragment } from 'react';

import type { SectionData } from '@/app/[locale]/how-it-works/_data/timelineSections';

import StickyTimelineSegment from './StickyTimelineSegment';

export interface StickyTimelineProps {
  readonly activeIndex: number;
  readonly sections: SectionData[];
}

const StickyTimeline = ({
  activeIndex,
  sections,
}: StickyTimelineProps): JSX.Element => {
  const activeSection = sections[activeIndex];
  const variant = activeSection!.variant;
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute left-0 top-0 z-20 size-full"
    >
      <div
        className={cx(
          'sticky top-0 hidden h-screen px-8 py-24 transition-colors duration-1000 lg:js:flex lg:js:items-center',
          {
            'text-sandstone-200': variant.sm === 'dark',
            'text-sandstone-500': variant.sm === 'light',
            'lg:text-sandstone-200': variant.lg === 'dark',
            'lg:text-sandstone-500': variant.lg === 'light',
          },
        )}
        data-cy="sticky_timeline"
        style={{ transform: 'scale(-1)', writingMode: 'vertical-lr' }}
      >
        {[...sections].reverse().map(({ id, time }, i) => (
          <Fragment key={id}>
            <StickyTimelineSegment
              activeIndex={activeIndex}
              id={id}
              index={i}
              sectionCount={sections.length}
              time={time}
            />
            {i < sections.length - 1 && (
              <div
                className={cx(
                  'w-px flex-1 bg-current transition-opacity duration-1000',
                  {
                    'opacity-30': sections.length - 2 - activeIndex >= i,
                  },
                )}
                data-cy="sticky_timeline_segment_line"
              />
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default StickyTimeline;
